module.exports = __webpack_public_path__ + "img/dbde0ad.svg";